import { render, staticRenderFns } from "./askExam.vue?vue&type=template&id=189297f2&scoped=true&"
import script from "./askExam.vue?vue&type=script&lang=js&"
export * from "./askExam.vue?vue&type=script&lang=js&"
import style0 from "./askExam.vue?vue&type=style&index=0&id=189297f2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189297f2",
  null
  
)

export default component.exports